import { Col, Row } from "reactstrap"
import styles from "./Yearly.module.scss"
import Tick from "../../../../../../assets/images/SellerPortalImages/Subscription/payment-blue-tick.png"

const Yearly = () => {
  return (
    <section>
      <Row>
        <Col xs='12' lg='4' className="d-flex justify-content-center">
          <div className={`shadow ${styles.wrapper}`}>
            <Row className="g-0 d-flex align-items-center justify-content-between">
              <Col>
                <div className={styles.label}>
                  <div>
                    $50 <sub>/</sub>{" "}
                  </div>
                  <div className="text-muted">mo</div>
                </div>
              </Col>
              <Col xs='7'>
                <div className={`${styles["tag"]} ${styles["tag-global"]}`}>Global Seller</div>
              </Col>
            </Row>

            <div className="px-3 pb-3">
              <div className="my-3">For individuals living abroad who want to run a business in their home country using the platform.</div>

              <div className="d-flex gap-2 align-items-center">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Remote store management</div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Cross-border payment support.</div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Currency conversion tools.</div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Advanced analytics and performance tracking.</div>
              </div>

              <div className="text-center mt-3">
                <div className={`${styles.btn} ${styles["btn-global"]} cursor-pointer`}>GET STARTED</div>
              </div>
            </div>
          </div>
        </Col>

        <Col xs='12' lg='4' className="d-flex justify-content-center">
          <div className={`shadow ${styles.wrapper}`}>
            <Row className="g-0 d-flex align-items-center justify-content-between">
              <Col>
                <div className={styles.label}>
                  <div>
                    $50 <sub>/</sub>{" "}
                  </div>
                  <div className="text-muted">mo</div>
                </div>
              </Col>
              <Col xs='7'>
                <div className={`${styles["tag"]} ${styles["tag-fbm"]}`}>FBM</div>
              </Col>
            </Row>

            <div className="px-3 pb-3">
              <div className="my-3">For individuals living abroad who want to run a business in their home country using the platform.</div>

              <div className="d-flex gap-2 align-items-center">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Remote store management</div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Cross-border payment support.</div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Currency conversion tools.</div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Advanced analytics and performance tracking.</div>
              </div>

              <div className="text-center mt-3">
                <div className={`${styles.btn} ${styles["btn-seller"]} cursor-pointer`}>GET STARTED</div>
              </div>
            </div>
          </div>
        </Col>

        <Col xs='12' lg='4' className="d-flex justify-content-center">
          <div className={`shadow ${styles.wrapper}`}>
            <Row className="d-flex align-items-center justify-content-between">
              <Col>
                <div className={styles.label}>
                  <div>
                    $50 <sub>/</sub>{" "}
                  </div>
                  <div className="text-muted">mo</div>
                </div>
              </Col>
              <Col xs='7'>
                <div className={`${styles["tag"]} ${styles["tag-hire-model"]}`}>Hire Model</div>
              </Col>
            </Row>

            <div className="px-3 pb-3">
              <div className="my-3">For individuals living abroad who want to run a business in their home country using the platform.</div>

              <div className="d-flex gap-2 align-items-center">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Remote store management</div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Cross-border payment support.</div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Currency conversion tools.</div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <img src={Tick} width={24} height={24} alt="" />
                <div>Advanced analytics and performance tracking.</div>
              </div>

              <div className="text-center mt-3">
                <div className={`${styles.btn} ${styles["btn-hire-model"]} cursor-pointer`}>GET STARTED</div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  )
}

export default Yearly
